import { render, staticRenderFns } from "./AutomaticReportJobDetailsTable.vue?vue&type=template&id=6e461c7c&"
import script from "./AutomaticReportJobDetailsTable.vue?vue&type=script&lang=ts&"
export * from "./AutomaticReportJobDetailsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports